import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as NotFound } from '../../assets/img/notFound.svg';

const NoData = () => {
    const { t } = useTranslation();
    return (
        <Grid container alignItems={'center'} justifyContent={'center'} flexWrap="wrap">
            <Grid item>
                <NotFound style={{ width: '300px' }} />
            </Grid>
            <Grid item>
                <h3 style={{ margin: '16px 0' }}>{t('errors.noData.title', { ns: 'common' })}</h3>
                <span>{t('errors.noData.content', { ns: 'common' })}</span>
            </Grid>
        </Grid>
    );
};

export default NoData;
